import { render, staticRenderFns } from "./DialogEditCompanyUsers.vue?vue&type=template&id=a97f9980&scoped=true"
import script from "./DialogEditCompanyUsers.vue?vue&type=script&lang=js"
export * from "./DialogEditCompanyUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97f9980",
  null
  
)

export default component.exports